'use strict';

const { getAdformConfig } = require('./common/jsConfig');

// note: config is validated by adformConfigValidator.js (and covered with tests)
// in case of new properties in container_type objects, please update validator and tests

const CATEGORY_DESKTOP = {
    w: '1300',
    h: '325'
};

const CATEGORY_MOBILE = {
    w: '516',
    h: '258'
};

const NUM_OF_BIDS_50 = 50; // current value represents unlimited bids (todo: implement this logic)

let adformCategoriesSponsoredProductsAdsPositions;
try {
    adformCategoriesSponsoredProductsAdsPositions = getAdformConfig('adformCategoriesSponsoredProductsAdsPositions')
        .split(',')
        .map(item => parseInt(item))
        .filter(item => item >= 0);
} catch (e) {
    adformCategoriesSponsoredProductsAdsPositions = [];
}

module.exports = {
    FETCH_BIDS_URL: getAdformConfig('adform_FETCH_BIDS_URL'),
    FETCH_TIMEOUT_MS: 5000,
    BUYER_UID_FALLBACK: '611863963459000000', // Testing
    IP_ADDRESS_FALLBACK: getAdformConfig('adformFallbackIp'),
    ASSET_ID_MOBILE_IMG: 1,
    ASSET_ID_DESCRIPTION: 2,
    ASSET_ID_DESKTOP_IMG: 3,
    ASSET_ID_TITLE: 4,
    getAdformAssetsDomainRegex: () => {
        const adformAssetsDomainRegex = getAdformConfig('adformAssetsDomainRegex');

        return adformAssetsDomainRegex ? adformAssetsDomainRegex.trim() : '';
    },
    ADFORM_ASSETS_DOMAIN_REPLACEMENT: getAdformConfig('adform_ADFORM_ASSETS_DOMAIN_REPLACEMENT'),
    CONTAINER_TYPE_HOMEPAGE_CONFIG: {
        isInSlider: true,
        tagId: getAdformConfig('adformTagIdHomepageBanner'),
        numOfBids: NUM_OF_BIDS_50,
        desktop: {
            w: '1646',
            h: '412'
        },
        isMobileImgRequired: true,
        mobile: {
            w: '1000',
            h: '1000'
        }
    },
    CONTAINER_TYPE_CATEGORY_CONFIG: {
        isInSlider: true,
        tagId: getAdformConfig('adformTagIdCategoriesBanner'),
        numOfBids: NUM_OF_BIDS_50,
        desktop: CATEGORY_DESKTOP,
        isMobileImgRequired: true,
        mobile: CATEGORY_MOBILE
    },
    CONTAINER_TYPE_SUB_CATEGORY_CONFIG: {
        isInSlider: true,
        tagId: getAdformConfig('adformTagIdSubCategoriesBanner'),
        numOfBids: NUM_OF_BIDS_50,
        desktop: CATEGORY_DESKTOP,
        isMobileImgRequired: true,
        mobile: CATEGORY_MOBILE
    },
    CONTAINER_TYPE_NAV_CONFIG: {
        isInSlider: false,
        tagId: getAdformConfig('adformTagIdNavigationBanner'),
        isMegaMenuAd: true,
        numOfBids: 1,
        desktop: {
            w: '250',
            h: '500'
        },
        isMobileImgRequired: false,
        mobile: {}
    },
    CATEGORIES_SPONSORED_PRODUCT_ADS_TAG_ID: getAdformConfig('adformTagIdCategoriesSponsoredProductsAds'),
    CATEGORIES_SPONSORED_PRODUCT_ADS_NUM_OF_BIDS: 5,
    CATEGORIES_SPONSORED_PRODUCT_ADS_ON_PAGES: [1, 2, 3],
    CATEGORIES_SPONSORED_PRODUCT_ADS_POSITIONS: adformCategoriesSponsoredProductsAdsPositions,
    HOMEPAGE_REQUEST_SITE_PAGE: '/',
    BIDS_READY_CUSTOM_EVENT_NAME: 'adform:bids-handler:bids-ready',
    NO_BIDS_CUSTOM_EVENT_NAME: 'adform:bids-handler:no-bids',
    PRODUCT_BIDS_READY_CUSTOM_EVENT_NAME: 'adform:product:bids-handler:bids-ready',
    PRODUCT_NO_BIDS_CUSTOM_EVENT_NAME: 'adform:product:bids-handler:no-bids',
    FEATURED_BLOCK_NUM_OF_BIDS: 1,
    FEATURED_BLOCK_DESKTOP: {
        w: '2880',
        h: '1034'
    },
    FEATURED_BLOCK_MOBILE: {
        w: '1000',
        h: '1000'
    },
    FEATURED_BLOCK_TAG_IDS: [
        getAdformConfig('adformTagIdFeaturedBlockFirst'),
        getAdformConfig('adformTagIdFeaturedBlockSecond'),
        getAdformConfig('adformTagIdFeaturedBlockThird')
    ],
    FEATURED_BLOCK_BANNER_POSITIONS: [
        'left', 'right', 'left'
    ],
    FEATURED_BLOCK_BIDS_READY_CUSTOM_EVENT_NAME: 'adform:featured-block:bids-handler:bids-ready',
    FEATURED_BLOCK_NO_BIDS_CUSTOM_EVENT_NAME: 'adform:featured-block:bids-handler:no-bids',

    LISTPAGE_REQUEST_SITE_PAGE: '/search',
    LISTPAGE_TILE_BANNER_DESKTOP: {
        w: '257',
        h: '501'
    },
    LISTPAGE_TILE_BANNER_MOBILE: {
        w: '516',
        h: '258'
    },
    LISTPAGE_TILE_BANNER_NUM_OF_BIDS: 100,

    HOMEPAGE_RECOMMENDED_PRODUCTS_NUM_OF_BIDS: 3,
    HOMEPAGE_RECOMMENDED_PRODUCTS_ADS_POSITIONS: [1, 2, 5],
    HOMEPAGE_RECOMMENDED_PRODUCTS_TAG_ID: getAdformConfig('adformTagIdHomepageRecommendedProducts'),
    HOMEPAGE_RECOMMENDED_PRODUCTS_BIDS_READY_CUSTOM_EVENT_NAME: 'adform:homepage-recommended-products:bids-handler:bids-ready',
    HOMEPAGE_RECOMMENDED_PRODUCTS_NO_BIDS_CUSTOM_EVENT_NAME: 'adform:homepage-recommended-products:bids-handler:no-bids',

    PDP_PRODUCTS_SLIDER_NUM_OF_BIDS: 5,
    PDP_PRODUCTS_SLIDER_BIDS_READY_CUSTOM_EVENT_NAME: 'adform:pdp-products-slider:bids-handler:bids-ready',
    PDP_PRODUCTS_SLIDER_NO_BIDS_CUSTOM_EVENT_NAME: 'adform:pdp-products-slider:bids-handler:no-bids',

    BID_IMG_JS_CLASS: 'js-bid-img',
    BID_INTERSECTION_INDICATOR_JS_CLASS: 'js-intersection-indicator'
};
